import React from 'react';
import Typography from '@mui/material/Typography';
import PhoneIcon from '@mui/icons-material/Phone';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import translations from './translations';
import { getTranslation } from '../../../../utils/translations';
import AlertBox from '../../../../uikit/info/AlertBox';
import { Spacer } from '../../../../uikit/misc/Spacer';
import useEmotionStyles from '../../../../uikit/hooks/useEmotionStyles';
var t = getTranslation(translations);
var styles = function (theme) {
    var _a;
    return ({
        point: {
            display: 'flex',
            marginBottom: theme.spacing(2),
        },
        icon: (_a = {
                textAlign: 'center',
                width: '80px'
            },
            _a[theme.breakpoints.down('md')] = {
                textAlign: 'left',
                width: '50px',
            },
            _a),
        content: {
            flex: 1,
        },
    });
};
var FinalScreenPoint = function (_a) {
    var Icon = _a.icon, title = _a.title, description = _a.description;
    var cs = useEmotionStyles(styles);
    return (React.createElement("div", { className: cs.point },
        React.createElement("div", { className: cs.icon },
            React.createElement(Icon, { color: 'primary', fontSize: 'large' })),
        React.createElement("div", { className: cs.content },
            React.createElement(Typography, { variant: 'body1' }, title),
            React.createElement(Typography, { variant: 'body2' }, description))));
};
export var FinalScreen = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(AlertBox, { title: t.messageBoxTitle, content: t.messageBoxContent }),
        React.createElement(Spacer, { size: 2 }),
        React.createElement(Typography, { variant: 'body1' }, t.listTitle),
        React.createElement(Spacer, { size: 2 }),
        React.createElement(FinalScreenPoint, { icon: PhoneIcon, title: "1. ".concat(t.personalAdvicePointTitle), description: t.personalAdvicePointDescription }),
        React.createElement(FinalScreenPoint, { icon: PendingActionsIcon, title: "2. ".concat(t.financingOfferPointTitle), description: t.financingOfferPointDescription })));
};
export default FinalScreen;
